import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from "@react-pdf/renderer";
import logo from '../../assets/fonts/jc-logo.png';
import numeral from "numeral";

const styles = StyleSheet.create({
  body: {
    paddingTop: 65,
    paddingBottom: 65,
    paddingHorizontal: 20,
    fontFamily:'Helvetica',
    //fontFamily:'Helvetica-Bold' since fontWeight:500 doesnt work here
    //https://github.com/diegomura/react-pdf/issues/402 ->fontWeight will not work, but specify a bold-font instead lol
  },
  brbr:{
  	marginBottom:'10',
  },
  upup:{
    marginTop:'20',
    fontSize:'15',
  },
  pkg1:{
    marginTop:'40',
    minWidth:'100%',
    paddingRight:'25',
    borderBottom:'1 solid black',
  },
  pkg2:{
    marginTop:'40',
    minWidth:'100%',
    paddingRight:'25',
    borderBottom:'1 solid black',
  },
  box: {
      display:'flex',
      flexDirection: 'row',
      justifyContent:'flex-start',
      marginTop:'30',
  },
  noteBox: {
      marginTop:'5',
  },
  noteText:{
    fontSize:'8',
    paddingLeft:'10',
  },
  totalTextBold:{
    fontSize:'8',
    paddingLeft:'10',
    fontFamily:'Helvetica-Bold',
  },
  leftPart: {
    	minWidth:'50%',
  },
  rightPart: {
    	minWidth:'50%',
    	marginLeft:'15'
  },
  pLeftPart: {
    minWidth:'50%',
    maxWidth:'50%',
 },
  pRightPart: {
      minWidth:'50%',
      maxWidth:'50%',
  },
  tblTitle : {
    fontSize:'9',
    marginBottom: '15',
    fontFamily:'Helvetica-Bold',
  },
  
  tableItems:{
      display:'flex',
      flexDirection: 'row',   
      borderBottom: '1',
      marginBottom: '4',
  },
  header1: {
    	minWidth:'85%',
        fontSize: '16',
  },header2: {
    	minWidth:'15%',
        fontSize: '16',
  },
  item1: {
    	minWidth:'85%',
        maxWidth:'85%',
        fontSize: '7',
  },
  item2: {
        fontSize: '7',
  },
  rightAlign:{
    minWidth:'100%',
    paddingRight:'50',
    alignItems:'flex-end',
  },
  paymentInfo: {
        display: 'flex',
        flexDirection: 'row',
      	justifyContent:'flex-start',
    	marginBottom: '5',
  },

  	cvItems:{
      marginTop: '7',
      display:'flex',
      flexDirection: 'row',
      justifyContent:'flex-start'
    },
  
	cvTableHeader:{
      marginTop: 15,
      display:'flex',
      flexDirection: 'row',
      borderTop:'1 solid black',
      justifyContent:'flex-start'
    },
    blackBorder:{
     marginTop:'7',
     borderBottom:'1 solid black',
    },
  
    cvTblHeader1:{
        fontSize: 8,
        minWidth:'35%',
        maxWidth:'35%',
    },
    cvTblHeader1Bold:{
      fontSize: 8,
      minWidth:'35%',
      maxWidth:'35%',
      fontFamily:'Helvetica-Bold',
  },
    cvTblHeader2:{
        fontSize: 8,
        minWidth:'20%',
        maxWidth:'20%',
        textAlign:'right',
    },
    cvTblHeader2Bold:{
      fontSize: 8,
      minWidth:'20%',
      maxWidth:'20%',
      textAlign:'right',
      fontFamily:'Helvetica-Bold',
  },
    cvTblHeader3:{
        fontSize: 8,
        minWidth:'20%',
        maxWidth:'20%',
        textAlign:'right',
    },
    cvTblHeader3Bold:{
      fontSize: 8,
      minWidth:'20%',
      maxWidth:'20%',
      textAlign:'right',
      fontFamily:'Helvetica-Bold',
  },
    cvTblHeader4:{
        fontSize: 8,
        minWidth:'25%',
        maxWidth:'25%',
        textAlign:'right',
    },
    cvTblHeader4Bold:{
      fontSize: 8,
      minWidth:'25%',
      maxWidth:'25%',
      textAlign:'right',
      fontFamily:'Helvetica-Bold',
  },
  innerBox: {
      fontSize:'8',
      display:'flex',
      flexDirection: 'row',
      justifyContent:'flex-start',
      marginBottom: '5',
  },
  innerLeftPart: {
      minWidth:'50%',
      maxWidth:'50%',
      alignItems:'flex-start',
},
innerLeftPart2: {
  minWidth:'100%',
  maxWidth:'100%',
  alignItems:'flex-start',
},
innerLeftPart3: {
  minWidth:'70%',
  maxWidth:'70%',
  marginRight:'20',
  alignItems:'flex-start',
},
innerRightPart: {
    minWidth:'40%',
    alignItems:'flex-end',
},
  innerLeftPayment: {
    	minWidth:'70%',
      maxWidth:'70%',
      alignItems:'flex-start',
  },
  approvedBy: {
     	minWidth:'100%',
        maxWidth:'100%',
        alignItems:'flex-start',
      	borderTop: '1',
        marginTop: '27'
  },
  approver:{
      fontSize:'8',
      textAlign:'left',
  },
  nestedItem1:{
    paddingLeft:'30'
  },
  nestedItem2:{
    paddingLeft:'51'
  },
    nestedItem2:{
    paddingLeft:'42'
  },
  nestedItem3:{
    paddingLeft:'51'
  },
  right:{
    alignSelf:'flex-end',
    fontSize: '8',
  },
  boldRight:{
    alignSelf:'flex-end',
    fontSize: '8',
    fontFamily:'Helvetica-Bold',
  },
  wrap:{
     marginBottom: '5',
  }, 
  mRight:{
     paddingLeft:'25',
  },
  title: {
    fontSize: '11',
    textAlign: 'center',
    fontFamily:'Helvetica-Bold',
  },
  text: {
    margin: '12',
    fontSize: '7',
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
  },
  header: {
    fontSize: 11,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 9,
    bottom: 30,
    left: -500,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  image: {
    position: 'absolute',
    width:'40px',
    height:'40px',
    left:19,
    top:45,
  },
});

  export function JcOnlineOrderPdf(props) {
    const {soInfo, items, payments} = props;
      return (
        <Document>
        <Page size="A4" style={styles.body}>
          <Text style={styles.title}>SALES ORDER - JC ONLINE SHOP</Text>
          <Image
            style={styles.image}
            src={logo}
          />
            <View style={styles.box}>
              <View style={styles.pLeftPart}>
                <Text style={styles.tblTitle}>Order Information</Text>

                   <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Sales Order #</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{soInfo.reference_no}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Transaction Date</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{soInfo.trandate}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Subtotal</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{numeral(soInfo.totalamt-soInfo.freight).format('0,0.00')}</Text></View>
                   </View>
                   <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Shipping Fee</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{numeral(soInfo.freight).format('0,0.00')}</Text></View>
                   </View>
                  <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Grand Total</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.boldRight}>{numeral(soInfo.totalamt).format('0,0.00')}</Text></View>
                   </View>
               </View>
              
              <View style={styles.pRightPart}>
                   <Text style={styles.tblTitle}>Delivery Details</Text>
                    <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart2}><Text style={styles.noteText}>{soInfo.customer_name}</Text></View>
                     </View>
                            <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart2}><Text style={styles.noteText}>{soInfo.mobile_no}</Text></View>
                     </View>
                        <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart2}><Text style={styles.noteText}>{soInfo.customer_address}</Text></View>
                     </View>
                
                	<View style={styles.brbr}></View>

               </View>
             </View>
          
         <View style={styles.cvTableHeader}>
            <Text style={styles.cvTblHeader1Bold}>Item</Text>
            <Text style={styles.cvTblHeader2Bold}>Price</Text>
            <Text style={styles.cvTblHeader3Bold}>Qty</Text>
            <Text style={styles.cvTblHeader4Bold}>Subtotal</Text>
         </View> 
          
          {items.map((item=>{
            return(
              <View style={styles.cvItems}>
                <Text style={styles.cvTblHeader1}>{item.item_name}</Text>
                <Text style={styles.cvTblHeader2}>{item.price}</Text>
                <Text style={styles.cvTblHeader3}>{item.qty}</Text>
                <Text style={styles.cvTblHeader4}>{item.total}</Text>
              </View> 
            )
          }))}
        <View style={styles.blackBorder}></View>  
          
 		<View style={styles.box}>
              <View style={styles.leftPart}>
                <Text style={styles.tblTitle}>Payment Information</Text>
                   <View style={styles.innerBox}>
                      <View style={styles.innerLeftPayment}>
              {payments.map((item=>{
                  return(<>
                  <View style={styles.paymentInfo}>
                    <View style={styles.innerLeftPart}>
                       <Text style={styles.noteText}>{item.payname||"Payment Type"}</Text>
                    </View>
                  <View style={styles.innerRightPart}>
                    <Text style={styles.noteText}>{numeral(item.amount).format('0,0.00')}</Text>
                  </View>
              </View>
            
              <View style={styles.paymentInfo}>
                    <View style={styles.innerLeftPart}>
                       <Text style={styles.noteText}>Total</Text>
                    </View>
                  <View style={styles.innerRightPart}>
                    <Text style={styles.totalTextBold}>{numeral(soInfo.totalamt).format('0,0.00')}</Text>
                  </View>
              </View></>)
                }))}
                      </View>
         
                   </View>
          	  </View>
        </View>
          
    <View style={styles.noteBox}>
       <View style={styles.leftPart}>
           <Text style={styles.tblTitle}>Notes</Text>
     	</View>
      	<Text style={styles.noteText}>{soInfo.notes}</Text>
    </View> 

     		<View style={styles.box}>
              <View style={styles.pLeftPart}>
                   <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart3}>
							                <View style={styles.approvedBy}><Text style={styles.approver}>Prepared By:</Text></View>
                              <View style={styles.approvedBy}><Text style={styles.approver}>Checked By:</Text></View>
                              <View style={styles.approvedBy}><Text style={styles.approver}>Release Date:</Text></View>
                        </View>

                        <View style={styles.innerRightPart}>
                              <Text style={styles.approver}>Packaging Materials</Text>
                              <View style={styles.pkg1}></View>
                              <View style={styles.pkg2}></View>
                       </View>
          	   </View>
            </View>    
        </View>      
          
         <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
        `Page ${pageNumber} / ${totalPages}`
      )} fixed />
        </Page>
      </Document>
       );
  }; 
   